import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fdff15e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag-container" }
const _hoisted_2 = {
  key: 0,
  class: "label-tag-row"
}
const _hoisted_3 = { class: "label-tag" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-tag-left" }, "年度", -1))
const _hoisted_5 = { class: "label-tag-right" }
const _hoisted_6 = { class: "tag-list" }

import { withDefaults, computed, CSSProperties } from 'vue'
import { AUTH_WAREHOUSE, OWN_WAREHOUSE } from '@/defination/malfunction-repair'

interface ServiceMapData {
  color: string
  onlyPingan?: boolean
}
type RenderItem = ServiceMapData & {
  text: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'network-services-tag',
  props: {
    tags: { default: () => [] },
    type: null,
    labelName: null
  },
  setup(__props: any) {

const props = __props as { tags: string[], type: string, labelName?: string };

// 网点标签数据


const labelName = computed(() => props.labelName)
const ownServiceMap: Record<string, ServiceMapData> = {
  付费服务: {
    color: '#F7981C',
  },
  质保服务: {
    color: '#1991EB',
  },
  增值服务: {
    color: '#33CF93',
  },
  其他服务: {
    color: 'rgba(0,0,0,0.44)',
  },
}
const authServiceMap: Record<string, ServiceMapData> = {
  极加22版: {
    color: '#33CF93',
  },
  质保服务: {
    color: '#1991EB',
  },
  意外机损保险: {
    color: '#33CF93',
  },
  不计免赔: {
    color: '#33CF93',
  },
  付费服务: {
    color: '#F7981C',
  },
}
const renderTagList = computed(() => {
  let result: Array<RenderItem> = []
  if (props.type === AUTH_WAREHOUSE) {
    // 授权网点
    result = props.tags.map((item) => {
      const data = authServiceMap[item]
      return data
        ? {
            ...data,
            text: item,
          }
        : null
    })
  } else if (props.type === OWN_WAREHOUSE) {
    // 直营网点
    result = props.tags.map((item) => {
      return ownServiceMap[item]
        ? {
            ...ownServiceMap[item],
            text: item,
          }
        : null
    })
  }
  return result.filter((item) => item)
})

function getTagStyle(item: RenderItem) {
  const result: CSSProperties = {
    color: item.color,
  }
  if (!item.onlyPingan) {
    result.border = `1px solid ${item.color}`
  }
  return result
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(labelName))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(labelName)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderTagList), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "tag-item",
          style: _normalizeStyle(getTagStyle(item)),
          key: index
        }, _toDisplayString(item.text), 5))
      }), 128))
    ])
  ]))
}
}

})